import { TShipmentOrder } from '@types';

export const isShipmentInvoiced = (shipment: TShipmentOrder | null | undefined): boolean => {
	const shipperPaymentStatusCode = shipment?.shipper_payment_status?.code ?? '';
	const carrierPaymentStatusCode = shipment?.carrier_payment_status?.code ?? '';
	const carrierIsAwaitingInvoice = carrierPaymentStatusCode === 'carrier-awaiting-invoice';
	return (shipment?.payment_status?.is_invoiced ?? false)
		|| !!shipperPaymentStatusCode
		|| (!!carrierPaymentStatusCode && !carrierIsAwaitingInvoice);
};
